import { cx } from '@mage-ui/styled-system/css';
import {
	table,
	tableCaption,
	tableHead,
	tableScroll,
	tableTr,
	text,
	textContainer,
} from '@mage-ui/styled-system/recipes';
import { Table as MantineTable } from '@mantine/core';

export const Table = ({ data, children, classNames, ...props }) => {
	return (
		<>
			{data?.fields?.subtitle && (
				<p className={text({ size: '3' })}>{data?.fields?.subtitle}</p>
			)}
			<div className={tableScroll()}>
				<MantineTable
					{...props}
					classNames={{
						table: cx(classNames?.table, table()),
						thead: tableHead(),
						tr: tableTr(),
					}}
				>
					{children}
				</MantineTable>
			</div>
			{data?.fields?.caption && (
				<div
					className={cx(tableCaption(), textContainer())}
					dangerouslySetInnerHTML={{
						__html: data?.fields?.caption || '',
					}}
				/>
			)}
		</>
	);
};
